/* Pachete brad decorat: caruselul de colecții, adăugarea în coș, cantitățile din pagina pachetului, galerie, „Alte colecții” */
(function(){
  function money(c){ return (c/100).toLocaleString("ro-RO",{minimumFractionDigits:2,maximumFractionDigits:2})+" lei"; }
  // pune piesele reale în coș (stocul scade pe fiecare piesă), cu proprietatea ascunsă _Pachet, apoi deschide coșul
  function add(items,name,btn,msg){
    var list=items.filter(function(i){ return i.quantity>0; }).map(function(i){ return {id:i.id,quantity:i.quantity,properties:{_Pachet:name}}; });
    if(!list.length) return;
    btn.setAttribute("aria-busy","true");
    fetch("/cart/add.js",{method:"POST",headers:{"Content-Type":"application/json","Accept":"application/json"},body:JSON.stringify({items:list})})
      .then(function(r){ return r.json().then(function(j){ return {ok:r.ok,j:j}; }); })
      .then(function(res){
        btn.removeAttribute("aria-busy");
        if(res.ok){ var t=document.querySelector("[data-cart-toggle]"); if(t) t.click(); else location.href="/cart"; }
        else if(msg){ msg.textContent=res.j.description||"Nu am putut adăuga pachetul în coș."; msg.hidden=false; }
      })
      .catch(function(){ btn.removeAttribute("aria-busy"); });
  }

  // ===== pagina colecției: carusel fără reîncărcare =====
  var pc=document.querySelector("[data-pc]"), pcData=pc&&pc.querySelector("[data-pc-data]");
  if(pcData){
    var S=JSON.parse(pcData.textContent), n=S.length;
    var stage=pc.querySelector("[data-pc-stage]"), slides=[].slice.call(stage.querySelectorAll(".pc-slide"));
    var dots=[].slice.call(pc.querySelectorAll(".pc-dots a")), info=pc.querySelector("[data-pc-info]");
    var prevA=pc.querySelector("[data-pc-prev]"), nextA=pc.querySelector("[data-pc-next]");
    var cur=slides.findIndex(function(s){ return s.classList.contains("is-cur"); }), timer=null;
    // poziția unui brad față de cel din mijloc (caruselul se închide în cerc)
    function rel(i){ var o=i-cur, h=Math.floor(n/2); if(o>h) o-=n; if(o<-h) o+=n; return o; }
    function cls(o){ return o===0?"is-cur":o===-1?"is-prev":o===1?"is-next":o<0?"is-far-l":"is-far-r"; }
    function load(img){ if(img.dataset.src){ img.srcset=img.dataset.srcset; img.src=img.dataset.src; img.removeAttribute("data-src"); img.removeAttribute("data-srcset"); } }
    function go(i){
      i=(i+n)%n; if(i===cur) return;
      var d=S[i];
      if(d.prods){ location.href=d.u; return; } // colecția are produse sub brad: pagina completă
      cur=i;
      slides.forEach(function(s,k){ var o=rel(k); s.className="pc-slide "+cls(o); if(o>=-2&&o<=2) load(s); });
      dots.forEach(function(a,k){ if(k===cur) a.setAttribute("aria-current","true"); else a.removeAttribute("aria-current"); });
      if(prevA){ prevA.href=S[(cur-1+n)%n].u; nextA.href=S[(cur+1)%n].u; }
      var prods=pc.querySelector("[data-pc-prods]"); if(prods) prods.hidden=true;
      // textele se schimbă cu o estompare scurtă
      info.classList.add("is-fading"); clearTimeout(timer);
      timer=setTimeout(function(){
        pc.querySelector("[data-pc-title]").textContent=d.t;
        var cr=pc.querySelector("[data-pc-crumb]"); if(cr) cr.textContent=d.t;
        pc.querySelector("[data-pc-price]").innerHTML=d.n+" decorațiuni · de la <strong>"+d.pr+"</strong>";
        pc.querySelector("[data-pc-link]").href=d.p;
        info.classList.remove("is-fading");
      },220);
      document.title=document.title.replace(/^[^|]*/,d.t+" ");
      history.replaceState(null,"",d.u);
    }
    function nav(e,i){ e.preventDefault(); go(i); }
    if(prevA){
      prevA.addEventListener("click",function(e){ nav(e,cur-1); });
      nextA.addEventListener("click",function(e){ nav(e,cur+1); });
    }
    dots.forEach(function(a,k){ a.addEventListener("click",function(e){ nav(e,k); }); });
    slides.forEach(function(s,k){ s.addEventListener("click",function(){ var o=rel(k); if(o===-1||o===1) go(k); }); });
    var x0=null;
    stage.addEventListener("touchstart",function(e){ x0=e.touches[0].clientX; },{passive:true});
    stage.addEventListener("touchend",function(e){
      if(x0===null) return;
      var dx=e.changedTouches[0].clientX-x0; x0=null;
      if(Math.abs(dx)>=50) go(cur+(dx<0?1:-1));
    });
    pc.querySelector("[data-pachet-quick]").addEventListener("click",function(){
      var d=S[cur]; add(d.items.map(function(i){ return {id:i.id,quantity:i.def}; }),d.name,this,null);
    });
  }

  // ===== pagina pachetului =====
  var root=document.querySelector("[data-pachet]");
  if(!root) return;
  var D=JSON.parse(root.querySelector("[data-pachet-data]").textContent);
  var rows=[].slice.call(root.querySelectorAll("[data-row]"));
  var treeRow=root.querySelector("[data-tree]"), resetEl=root.querySelector("[data-reset]"), addBtn=root.querySelector("[data-add]");
  var totalEl=root.querySelector("[data-total]"), countEl=root.querySelector("[data-count]"), msg=root.querySelector("[data-msg]");
  var addLabel=addBtn.textContent, q, withTree=false;
  function reset(){ q=D.items.map(function(i){ return i.def; }); }
  // textul de sub piesă când cantitatea diferă de rețetă
  function diffText(n,r){ return n>r ? "+"+(n-r)+" față de rețetă" : n===0 ? "Scos din colet" : (r-n)+" mai puțin decât în rețetă"; }
  function render(){
    var t=0,n=0,changed=false;
    rows.forEach(function(r,i){
      var it=D.items[i], d=r.querySelector("[data-diff]"), dif=it.avail&&q[i]!==it.q;
      r.querySelector("[data-q]").textContent=q[i];
      r.querySelector("[data-dec]").disabled=q[i]<=0;
      r.querySelector("[data-inc]").disabled=!it.avail||(it.max!==null&&q[i]>=it.max);
      r.classList.toggle("is-zero",it.avail&&q[i]===0);
      d.hidden=!dif; if(dif) d.textContent=diffText(q[i],it.q);
      if(q[i]!==it.def) changed=true;
      t+=q[i]*it.price; n+=q[i];
    });
    // bradul apare în listă și în total doar la „Decorul și bradul”
    if(treeRow) treeRow.hidden=!withTree;
    if(withTree&&D.tree){ t+=D.tree.price; n+=1; }
    // „Revino la rețeta noastră” apare doar când cantitățile diferă de rețetă
    resetEl.hidden=!changed;
    addBtn.disabled=n===0; addBtn.textContent=n===0?"Coletul e gol":addLabel;
    totalEl.textContent=money(t); countEl.textContent=n;
  }
  rows.forEach(function(r,i){
    r.querySelector("[data-dec]").addEventListener("click",function(){ if(q[i]>0){ q[i]--; render(); } });
    r.querySelector("[data-inc]").addEventListener("click",function(){ q[i]++; render(); });
  });
  root.querySelectorAll("[name=pachet-opt]").forEach(function(inp){
    inp.addEventListener("change",function(){
      withTree=root.querySelector("[name=pachet-opt]:checked").value==="brad";
      root.querySelectorAll(".pk-opt").forEach(function(l){ l.classList.toggle("is-on",l.querySelector("input").checked); });
      render();
    });
  });
  resetEl.addEventListener("click",function(e){ e.preventDefault(); reset(); render(); });
  addBtn.addEventListener("click",function(){
    var items=D.items.map(function(it,i){ return {id:it.id,quantity:q[i]}; });
    if(withTree&&D.tree) items.unshift({id:D.tree.id,quantity:1});
    add(items,D.name,this,msg);
  });
  // galerie: miniaturi
  root.querySelectorAll("[data-thumb]").forEach(function(b){
    b.addEventListener("click",function(){
      var k=b.getAttribute("data-thumb");
      root.querySelectorAll("[data-slide]").forEach(function(s){
        var on=s.getAttribute("data-slide")===k; s.hidden=!on;
        var v=s.querySelector("video"); if(v&&!on) v.pause();
      });
      root.querySelectorAll("[data-thumb]").forEach(function(x){ x.setAttribute("aria-pressed",x===b?"true":"false"); });
    });
  });
  // „Alte colecții”: săgeți
  var row=root.querySelector("[data-oc-row]");
  root.querySelectorAll("[data-oc]").forEach(function(b){
    b.addEventListener("click",function(){ row.scrollBy({left:(b.getAttribute("data-oc")==="next"?1:-1)*row.clientWidth*.8,behavior:"smooth"}); });
  });
  reset(); render();
})();
